import { useState, useEffect } from "react";
import { Button, SvgIcon } from "@mui/material";

import "./style.scss";
import { ReactComponent as TrashIcon } from "../../../assets/trash.icon.svg";
import { ModalTemplate } from "../../modal-template/modal-template.comp";
import { KBMultiSelect, KBOption } from "./kb-multi-select.comp";

export const BulkRemoveModal = ({
    open,
    knowledgeBases,
    handleClose,
    handleAction
}: {
    open: boolean;
    knowledgeBases: KBOption[];
    handleClose: () => void;
    handleAction: (kbs: KBOption[]) => void;
}) => {
    const [selectedKBs, setSelectedKBs] = useState<KBOption[]>([]);

    // Start with nothing selected each time the dialog opens; the admin picks
    // which of the selected users' assistants to remove them from.
    useEffect(() => {
        if (open) {
            setSelectedKBs([]);
        }
    }, [open]);

    const handleCloseClick = () => {
        handleClose();
        setSelectedKBs([]);
    };

    const handleActionClick = () => {
        if (selectedKBs.length > 0) {
            handleAction(selectedKBs);
            setSelectedKBs([]);
        }
    };

    return (
        <ModalTemplate
            open={open}
            width={654}
            handleClose={handleCloseClick}
            ariaLabel="Remove from Assistants"
        >
            <div className="um-add-users-modal">
                <div className="um-add-users-modal-title">
                    <SvgIcon
                        className="um-add-users-modal-title__icon"
                        component={TrashIcon}
                        inheritViewBox
                    />
                    <span className="um-add-users-modal-title__text">Remove from Assistants</span>
                </div>
                <div className="um-add-users-modal-description">
                    <span className="um-add-users-modal-description__text">
                        Select the assistants to remove the selected user(s) from.
                    </span>
                </div>
                <div className="um-add-users-modal-field">
                    {/* Visual caption only; KBMultiSelect names itself via aria-label. */}
                    <span className="um-add-users-modal-field__label">Assistants</span>
                    <KBMultiSelect
                        knowledgeBases={knowledgeBases}
                        selectedKBs={selectedKBs}
                        setSelectedKBs={setSelectedKBs}
                    />
                </div>
                <div className="um-add-users-modal-action">
                    <Button
                        className="primary-button"
                        variant="text"
                        onClick={handleActionClick}
                        disabled={selectedKBs.length === 0}
                    >
                        Remove
                    </Button>
                </div>
            </div>
        </ModalTemplate>
    );
};
